import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../../utils/apollo/api'
import { useModalData, useMoveBack } from '../../../../../components/modals/ModalsContext'
import { appendIf } from '@btime/helpers'
import { useNotification } from '@btime/react-messager'

const MUTATION = gql`
  mutation UpsertConfig($input: ConfigInput) {
    upsertConfig(input: $input) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.value?.checklists?.length, {
      path: ['value', 'checklists'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.places?.length, {
      path: ['value', 'places'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.sla_type, {
      path: ['value', 'sla_type'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.sla_unit, {
      path: ['value', 'sla_unit'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.sla_value, {
      path: ['value', 'sla_value'],
      message: 'Campo obrigatório'
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveConfig = () => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Config', 'Configs'],
    client: generalClient
  })
  const modalData = useModalData()
  const moveBackHistory = useMoveBack()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)
    if (isValid) {
      const input = cleanRequest(form, modalData)

      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: 'Configuração de SLA salva com sucesso!' })
          moveBackHistory()
        } else {
          notify.error({ title: `Ocorreu um erro ao salvar configuração de SLA!` })
        }
      })
    }
  }

  return [handleRequest, state]
}
